<mat-toolbar color="primary" fxLayoutAlign="space-between center" fxLayout="row" color="primary">
  <span>Audit</span>
  <button [attr.guide]="'audit-btn-1' + '__' + sanitizedUrl" mat-dialog-close (click)="close()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div class=" products-padding">


  <div class="editSets" fxLayout="column" *ngIf="type=='1'">
   <calsoft-audit-table [id]="id" [name]="name">

   </calsoft-audit-table>
  </div>

  <div *ngIf="type=='2'">


    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab [attr.guide]="'audit-tab-2' + '__' + sanitizedUrl" *ngFor="let tab of tabs;let i=index" [label]="tab.name">
        <ng-template matTabContent>
          <div *ngIf="init">
       
            <calsoft-audit-table [id]="id" [name]="tab.name">

            </calsoft-audit-table>
            
         
          </div>
   
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>


  <div class=" products-padding" fxLayout="row" fxLayoutAlign="space-between center">
    <!-- <button [attr.guide]="'audit-btn-3' + '__' + sanitizedUrl" mat-icon-button>
      <mat-icon (click)="auditDownload()">vertical_align_bottom</mat-icon>
    </button> -->
    <!-- <button [attr.guide]="'audit-btn-4' + '__' + sanitizedUrl" type="button" mat-raised-button color="primary">Done
    </button> -->
  </div>
</div>